var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSmallGreenTick = function SvgSmallGreenTick(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#169B62",
    fillRule: "evenodd",
    d: "M31.25 8.275 10.8 28.501.75 18.56l4.5-4.55 5.55 5.488L26.75 3.725z",
    clipRule: "evenodd"
  })));
};
export { SvgSmallGreenTick as ReactComponent };
export default __webpack_public_path__ + "images/smallGreenTick.svg";